import { Component, OnInit } from '@angular/core';
import { LoaderService } from '@app/core/business/ui/loader.service';

declare var jQuery: any;

@Component({
  selector: 'app-advertisement-while-waiting',
  templateUrl: './advertisement-while-waiting.component.html',
  styleUrls: ['./advertisement-while-waiting.component.scss']
})
export class AdvertisementWhileWaitingComponent implements OnInit {

  public ads: number[];
  private carousel: any;

  constructor(public loaderService: LoaderService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.carousel = jQuery('app-advertisement-while-waiting .owl-carousel-spe');
    if (this.carousel.length) {
      this.initOwlCarousel();
    }
  }

  ngAfterViewInit() {
    // Need to be done here instead of ngOnInit
    this.carousel = jQuery('app-advertisement-while-waiting .owl-carousel-spe');
    this.carousel.on('initialized.owl.carousel', function (event) {
      if (this.carousel) {
        this.carousel.trigger('refresh.owl.carousel');
      }
    });

    this.initOwlCarousel();
  }

  private initOwlCarousel() {
    this.carousel = jQuery('app-advertisement-while-waiting .owl-carousel-spe');
    if (this.carousel.length) {
      this.carousel.trigger('destroy.owl.carousel');
    }

    jQuery('app-advertisement-while-waiting .owl-item').remove();
    setTimeout(() => {
      this.carousel.owlCarousel({
        margin: 10,
        autoplayTimeout: 1000,
        nav: false,
        items: 1,
        center: true,
        singleItem: true,
        0: {
          items: 1,
        },
      });
    }, 100);
  }
}
